<template>
  <div>
    <!-- Footer -->
    <footer class="page-footer font-small unique-color-dark pt-4">
      <!-- Footer Elements -->
      <div class="container-fluid bcolor">
        <!-- Call to action -->
        <ul class="list-unstyled list-inline text-center py-2">
          <li class="list-inline-item">
            <h5 class="mb-1" style="color: white">
              Get connected with us on social networks!
            </h5>
          </li>
          <li class="list-inline-item">
            <div>
              <a
                href="https://sr-rs.facebook.com/Dogo-Di-Cattaro-992178320795339/"
                target="_blank"
              >
                <img src="face.svg" width="40px" alt="" class="mx-4"
              /></a>

              <a
                href="https://www.instagram.com/dogodicattaro/?hl=sr"
                target="_blank"
              >
                <img src="insta.png" width="40px" alt="" class="mx-4"
              /></a>
            </div>
          </li>
        </ul>
        <!-- Call to action -->
      </div>
      <!-- Footer Elements -->
      <div>
        <h5 class="ml-auto pt-3" style="color: white">Other information</h5>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/blogsAll">Blogs</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/DogsAll" class="nav-link" href="#">
              Ourdogs
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/female" class="nav-link" href="#"
              >Female</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/male" class="nav-link" href="#">Male</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/ancestors" class="nav-link" href="#"
              >Ancestors</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/puppies">Puppies</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/gallery">Gallery</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">Contact</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/SignIn">Sign In</router-link>
          </li>
          <li class="nav-item" v-if="user">
            <router-link class="nav-link" to="/dashboard"
              >Dashboard</router-link
            >
          </li>
          <li class="nav-item" v-if="user">
            <a class="nav-link" @click="onLogout">Logout</a>
          </li>
        </ul>
      </div>
      <!-- Copyright -->
      <div class="footer-copyright text-center py-3" style="color: grey">
        {{ new Date().getFullYear() }} — <strong>N studio</strong>
      </div>
      <!-- Copyright -->
    </footer>
    <!-- Footer -->
  </div>
</template>

<script>
export default {
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
  computed: {
    user() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
<style  scoped>
.bcolor {
  background-color: #daa520;
}
.navbar-nav {
  display: grid;
  grid-template-columns: repeat(4, 25%);
  justify-items: center;
}
.nav-link {
  color: #daa520;
  font-size: 13px;
}
@media (min-width: 359px) and (max-width: 992px) {
  .navbar-nav {
    grid-template-columns: repeat(2, 47%);
    justify-items: center;
    margin-left: 0;
  }
}
</style>